import React from 'react';
import PropTypes from 'prop-types';

const Hamburger = ({ onClick }) => (
  <svg
    className="hamburger"
    onClick={onClick}
    width="20"
    height="14"
    viewBox="0 0 20 14"
  >
    <defs>
      <path
        d="M0 1c0-.55229.44771-1 1-1h18c.5523 0 1 .44771 1 1 0 .55228-.4477 1-1 1H1c-.55229 0-1-.44772-1-1zm0 12c0-.5523.44771-1 1-1h18c.5523 0 1 .4477 1 1s-.4477 1-1 1H1c-.55229 0-1-.4477-1-1zm1-7c-.55229 0-1 .44772-1 1s.44771 1 1 1h18c.5523 0 1-.44772 1-1s-.4477-1-1-1H1z"
        id="hamburger-path-1"
      />
    </defs>
    <g id="hamburger-shape" stroke="none" fill="none">
      <use fillRule="evenodd" xlinkHref="#hamburger-path-1" />
    </g>
  </svg>
);

Hamburger.propTypes = {
  onClick: PropTypes.any,
};

export default Hamburger;
